import { render, staticRenderFns } from "./Paralax.vue?vue&type=template&id=1f284222&"
import script from "./Paralax.vue?vue&type=script&lang=js&"
export * from "./Paralax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports